import React from "react";
import { QRCodeCanvas } from "qrcode.react";

const QrCodePreview = ({ value, size = 80, level = "M", style }) => {
  if (!value) return null;
  return (
    <QRCodeCanvas
      value={value}
      size={size}
      level={level}
      includeMargin={false}
      style={{ width: "100%", height: "100%", ...style }}
    />
  );
};

export default QrCodePreview;
